var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultLearningImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66,463.59c-1.31-1.12-4.23-4.68-2-8.81.83-1.52,2.58-2.27,4.17-2.94a17,17,0,0,0,4.57-2.37c2.47-2.1,3.16-5.6,4.8-8.41,1.89-3.23,5.41-5.65,9.13-5.48,4.26.19,7.82,3.68,9.43,7.64s1.67,8.38,1.7,12.67c0,2.37-.09,5-1.83,6.64S92,464,89.78,464l-23.29-.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53,399.54H49.27l11,65.8a7.34,7.34,0,0,0,5.23,5.85,1.66,1.66,0,0,0,.21.06,4.92,4.92,0,0,0,.55.14,7.25,7.25,0,0,0,1.24.15v.06l.3-.05h27.3a7.82,7.82,0,0,0,7.7-6.58l5.32-45.33.24-1.8h0l2.11-17.95ZM99,441.51H92.69l.63-19.09h7.28Zm2.24-19.09h6L105,441.51H99.58Zm-18,40.26-.38-16.59h9l-.55,16.59Zm-9.78-16.59h8.79l.39,16.59H74.76Zm.68,16.59H66.77c-.7-4.48-1.61-10.3-2.6-16.59h8.69Zm-1-21.17-1.48-19.09H81.72l.44,19.09Zm9.66,0-.44-19.09H92.71l-.63,19.09Zm-.55-23.67-.41-17.68H93.45l-.59,17.68Zm-.61,0H71.27L69.9,400.16H81.21Zm-11,0H59.72c-.39-2.44-.75-4.76-1.08-6.84-1.15-7.15-1.58-9.83-1.81-10.84H69.29Zm.36,4.58,1.48,19.09h-9c-.3-1.94-.61-3.9-.92-5.86-.71-4.5-1.42-9-2.08-13.23Zm-8.18,19.09H56.93l-3.2-19.09h6.1C60.76,428.32,61.8,434.89,62.84,441.51Zm.72,4.58c.9,5.74,1.79,11.4,2.6,16.59H60.48L57.7,446.09ZM92,462.68l.55-16.59h6l-1.42,16.59Zm1.49-44.84.59-17.68h8.44L101,417.84ZM56.25,400.16c.24,1.27,1.36,8.23,2.86,17.68H53l-3-17.68Zm46.26,62.52H97.77l1.42-16.59h5.26Zm5.26-44.84H101.6l1.52-17.68h6.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.33,
    y: 353.47,
    width: 157.32,
    height: 72.56,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.91,422.6h-150V357.28h150Zm-149-1h148V358.26h-148Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.66,
    y: 353.47,
    width: 38.43,
    height: 72.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.42,377.5h149a.2.2,0,0,0,0-.4h-149a.2.2,0,0,0,0,.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41,377.3a162,162,0,0,0,.05-19.71.2.2,0,0,0-.4,0,162,162,0,0,0,.05,19.71.15.15,0,0,0,.3,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.52,367.45a2,2,0,1,1-2-2A2,2,0,0,1,270.52,367.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.32,367.45a2,2,0,1,1-2-2A2,2,0,0,1,192.32,367.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,389.94a2,2,0,1,1-2-2A2,2,0,0,1,232,389.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.14 426.02 162.04 471.57 166.6 471.57 181.53 426.02 170.14 426.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.53 426.02 304.3 471.65 299.74 471.65 286.14 426.02 297.53 426.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.94 426.02 335.61 471.65 331.06 471.65 316.55 426.02 327.94 426.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.82,410.48a2,2,0,1,1-2-2A2,2,0,0,1,231.82,410.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.42,400h149a.2.2,0,0,0,0-.4h-149a.2.2,0,0,0,0,.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.52,
    y: 300.34,
    width: 9.68,
    height: 47.57,
    transform: "translate(560.23 85.05) rotate(89.7)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.82,
    y: 319.37,
    width: 15.05,
    height: 53.02,
    transform: "translate(584.95 103.71) rotate(89.7)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.68,353.16a53.45,53.45,0,0,1-.26-7.52,53.54,53.54,0,0,1,.26-7.53,56.51,56.51,0,0,1,.25,7.53A56.42,56.42,0,0,1,256.68,353.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,353.16a56.42,56.42,0,0,1-.25-7.52,56.51,56.51,0,0,1,.25-7.53,55.42,55.42,0,0,1,.26,7.53A55.33,55.33,0,0,1,258.9,353.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.85,353.16a55.33,55.33,0,0,1-.26-7.52,55.42,55.42,0,0,1,.26-7.53,55.42,55.42,0,0,1,.26,7.53A55.33,55.33,0,0,1,221.85,353.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,353.16a53.45,53.45,0,0,1-.26-7.52,53.54,53.54,0,0,1,.26-7.53,56.51,56.51,0,0,1,.25,7.53A56.42,56.42,0,0,1,224.08,353.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.94,345.88c0-.14,5.34-.26,11.94-.26s12,.12,12,.26-5.35.26-12,.26S228.94,346,228.94,345.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.22,
    y: 300.75,
    width: 9.68,
    height: 65.42,
    transform: "translate(586.18 77.65) rotate(89.7)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.43,336.93a3.13,3.13,0,1,1,3.09-3.13A3.11,3.11,0,0,1,277.43,336.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.06,
    y: 311.9,
    width: 1.94,
    height: 43.79,
    transform: "translate(580.83 86.77) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.82,
    cy: 141.01,
    r: 106.41,
    transform: "translate(-25.95 219.37) rotate(-45)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.82,
    cy: 141.01,
    r: 85.13,
    transform: "translate(-25.95 219.37) rotate(-45)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.82,
    cy: 141.01,
    r: 63.84,
    transform: "translate(41.82 338.99) rotate(-72.56)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.82,
    cy: 141.01,
    r: 42.56,
    transform: "translate(20.5 313.6) rotate(-65.97)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.82,
    cy: 141.01,
    r: 21.28,
    transform: "translate(-36.56 129.45) rotate(-26.95)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.1 144.15 225.56 136.36 233.12 128.6 172 78.41 175.38 75.11 236.82 125 242.75 116.89 255.1 144.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,78.41l-.92.52a14.6,14.6,0,0,1-14.71-.2L130.76,63.35,148,60.64,146.14,42.5l23.57,16.14a14.61,14.61,0,0,1,5.67,16.48h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.9,397.44a25.26,25.26,0,0,1,6.73-16.7C434.66,389.12,425.9,397.44,425.9,397.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.66,392.72a25.23,25.23,0,0,1,18-.5C446.79,397.42,435.66,392.72,435.66,392.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.78,387.28a19.94,19.94,0,0,1,2.44-14C442.17,379.43,436.78,387.28,436.78,387.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,367.69C413.3,371.49,421,383.9,421,383.9,408.75,383.9,399,367.69,399,367.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.82,373.54c-.74-15.38,14.29-32.79,14.29-32.79-2.27,19.1-14.29,32.79-14.29,32.79",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.74,329.73a41.23,41.23,0,0,1-5.4,22C414.22,341.87,421.74,329.73,421.74,329.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,361c-11.25-1.2-17.37-12.39-17.37-12.39C412.18,352.4,416,361,416,361Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.69,408a25.26,25.26,0,0,1,17.68-3.41C403.43,410.85,391.69,408,391.69,408Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.83,413.06a16.57,16.57,0,0,1-7.55,8.51C413.76,416.38,420.83,413.06,420.83,413.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.39,411.4a20,20,0,0,1-13.45,2.4C410.27,409.29,419.39,411.4,419.39,411.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.14,432.11a.8.8,0,0,1,0-.23c0-.19,0-.41,0-.67,0-.64,0-1.5,0-2.58s0-2.49,0-4.08,0-3.4-.11-5.4c-.1-4-.38-8.75-.79-14s-1.1-11.05-2-17.09C420.41,376,418,365.17,416,357.41c-1-3.88-1.81-7-2.41-9.16-.29-1.05-.51-1.88-.68-2.49l-.16-.65a.93.93,0,0,1,0-.23.73.73,0,0,1,.09.22l.21.63.76,2.46c.67,2.14,1.55,5.26,2.58,9.13A285.16,285.16,0,0,1,422.69,388c.88,6,1.51,11.84,1.94,17.12s.63,10.05.68,14.06c.07,2,.05,3.81,0,5.4s0,3-.06,4.08-.07,1.95-.09,2.58c0,.27,0,.49,0,.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,399.55c.08-.12,4.62,2.86,10.15,6.65s9.94,6.95,9.86,7.07-4.62-2.86-10.15-6.65S404.42,399.66,404.5,399.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.51,401.19a4.23,4.23,0,0,1,.7-.77l2-1.95,6.76-6.34c2.59-2.43,4.93-4.63,6.76-6.33l2-1.93a4.53,4.53,0,0,1,.8-.66,4,4,0,0,1-.66.8c-.44.5-1.11,1.19-1.94,2-1.66,1.7-4,4-6.66,6.45s-5.08,4.67-6.86,6.24c-.89.78-1.62,1.4-2.14,1.83A4.3,4.3,0,0,1,424.51,401.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.06,392.26s11.62-.22,16.54,8.92A20.92,20.92,0,0,1,390.06,392.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.93,387.59s9.46,6.75,8,17A20.93,20.93,0,0,1,405.93,387.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.77,371s-3.73,13-15.6,15.35A24.39,24.39,0,0,1,455.77,371Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.77,322.6S415.6,332.27,414,348A31.88,31.88,0,0,1,400.77,322.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.12,408.63a6,6,0,0,1-1,.77c-.64.46-1.55,1.15-2.66,2a67.14,67.14,0,0,0-8,7.55,67.88,67.88,0,0,0-6.64,8.79c-.75,1.19-1.34,2.17-1.73,2.86a5.8,5.8,0,0,1-.67,1,6,6,0,0,1,.49-1.13c.34-.72.89-1.73,1.61-3a56.63,56.63,0,0,1,14.76-16.43c1.14-.85,2.09-1.5,2.76-1.91A5.88,5.88,0,0,1,450.12,408.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.21,418.29a25.26,25.26,0,0,1,3.41-17.68C442.21,411.63,437.21,418.29,437.21,418.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.19,412.85a18.41,18.41,0,0,1,12.94-2C453,414.64,447.19,412.85,447.19,412.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.52 433.31 409.08 469.87 441.4 469.87 448.9 433.84 403.52 433.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.38,456.74c0,.11-8.28.19-18.49.19s-18.5-.08-18.5-.19,8.28-.19,18.5-.19S444.38,456.64,444.38,456.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.51,455c0,.1-8.34.19-18.62.19s-18.63-.09-18.63-.19,8.34-.19,18.63-.19S444.51,454.84,444.51,455Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.44,452.92c0,.1-8.33.19-18.62.19s-18.62-.09-18.62-.19,8.34-.19,18.62-.19S444.44,452.81,444.44,452.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.79,467.79a31.24,31.24,0,0,1-1-4.61,30.71,30.71,0,0,1-.62-4.66,56,56,0,0,1,1.61,9.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,467.4a35.13,35.13,0,0,1-.4-4.49,34.23,34.23,0,0,1-.21-4.51,35.74,35.74,0,0,1,.61,9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,467.4a22.94,22.94,0,0,1-.84-4.61,22.26,22.26,0,0,1-.25-4.67,39.53,39.53,0,0,1,.62,4.63A42.45,42.45,0,0,1,419,467.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.81,467.59a23.57,23.57,0,0,1-.45-4.68,22.47,22.47,0,0,1,.15-4.7,41.55,41.55,0,0,1,.23,4.69A40.22,40.22,0,0,1,421.81,467.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.79,467.4a26.59,26.59,0,0,1-.34-4.44,26,26,0,0,1,0-4.46,26.64,26.64,0,0,1,.34,4.45A25.89,25.89,0,0,1,426.79,467.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.43,467.59a26.28,26.28,0,0,1-.15-4.59,29,29,0,0,1,.22-4.59,26.2,26.2,0,0,1,.15,4.59A29,29,0,0,1,430.43,467.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.84,467.1a30.24,30.24,0,0,1,.27-4.8,29.71,29.71,0,0,1,.66-4.76,31.05,31.05,0,0,1-.28,4.8A32,32,0,0,1,433.84,467.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.24,466.62a15.47,15.47,0,0,1,.54-4.08,16,16,0,0,1,1.2-3.94,36.71,36.71,0,0,1-.83,4A37.51,37.51,0,0,1,438.24,466.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.81,426.08v6.84a2.69,2.69,0,0,0,2.69,2.69h46.8a2.7,2.7,0,0,0,2.7-2.69v-6.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.87 435.61 404.25 437.79 447.44 440.87 448.53 435.61 403.87 435.61",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.65,470.81c0,.15-89.39.26-199.64.26S50.35,471,50.35,470.81s89.37-.26,199.66-.26S449.65,470.67,449.65,470.81Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.36,174.74s10.25,42,56.13,32.36C90.49,207.1,77.2,164.59,34.36,174.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.53,238.32s21.06,31.4,55.86,9.68C112.39,248,88.66,217.08,56.53,238.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.09,286.23s30.73,26.13,60.16-6.26C150.25,280,116.92,255.1,90.09,286.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.85,185.43s-34.08,16.38-17.54,53.92C106.74,238,138,219.54,121.85,185.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.25,230.69s-17,22.95,8.33,42.66C139.16,270.89,154,249,129.25,230.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.42,126.42s-3.91,34,32.84,39.48C83.26,165.9,85.05,130.64,50.42,126.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.13,92S73.4,104.41,86.31,139.25C86.31,139.25,116.1,124.39,103.13,92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,141.71S81.71,146.2,85.17,189C85.17,189,125.37,181.84,121.07,141.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,291.25l-.5-.15-1.48-.39c-1.29-.34-3.22-.8-5.64-1.59a108.49,108.49,0,0,1-19.81-8.34A120.4,120.4,0,0,1,124,262,133.32,133.32,0,0,1,111.3,248l-3-4c-.5-.66-1-1.33-1.49-2s-.93-1.4-1.39-2.1l-2.79-4.28-2.56-4.48-1.28-2.26-1.14-2.31c-.75-1.53-1.52-3.05-2.25-4.58l-2-4.62c-.32-.77-.66-1.53-1-2.3s-.56-1.54-.83-2.31l-1.64-4.58c-.46-1.54-.91-3.06-1.35-4.57-.22-.76-.45-1.51-.67-2.25s-.37-1.51-.55-2.25c-.35-1.5-.7-3-1-4.45A132.32,132.32,0,0,1,83.52,163a136.32,136.32,0,0,1,2.39-21.38c.53-2.49,1-4.41,1.3-5.71.14-.65.25-1.14.33-1.49s.1-.51.1-.51-.06.16-.15.5-.21.83-.37,1.47c-.32,1.31-.82,3.22-1.38,5.7A129.44,129.44,0,0,0,86,194.8c.34,1.47.69,2.95,1,4.46.19.75.33,1.51.55,2.26s.44,1.5.67,2.26c.44,1.51.89,3,1.35,4.58l1.64,4.6c.27.77.55,1.55.83,2.32s.64,1.53,1,2.3l2,4.65c.72,1.53,1.49,3.05,2.25,4.59.38.78.76,1.55,1.15,2.32s.85,1.51,1.28,2.27l2.57,4.5,2.8,4.29c.47.7.91,1.42,1.39,2.11l1.5,2,3,4a132.94,132.94,0,0,0,12.74,14,120,120,0,0,0,25.81,18.8,106.19,106.19,0,0,0,19.91,8.23c2.43.77,4.37,1.19,5.67,1.51l1.49.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.93,249.19a3.91,3.91,0,0,0,0,1c0,.62.14,1.51.28,2.6.26,2.2.72,5.22,1.36,8.52s1.37,6.28,1.94,8.41c.29,1.07.54,1.93.73,2.52a3.6,3.6,0,0,0,.33.9,4,4,0,0,0-.16-1l-.59-2.54c-.5-2.15-1.16-5.12-1.81-8.42s-1.14-6.3-1.49-8.48c-.16-1-.3-1.88-.42-2.58A4.08,4.08,0,0,0,132.93,249.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,283.27a3.83,3.83,0,0,0,1-.09l2.62-.38c2.2-.33,5.25-.76,8.62-1.15s6.44-.68,8.66-.87l2.63-.23a4.07,4.07,0,0,0,1-.14,4.38,4.38,0,0,0-1,0c-.63,0-1.53,0-2.64.09-2.23.11-5.31.35-8.69.74s-6.43.88-8.63,1.29c-1.09.2-2,.38-2.59.52A4.12,4.12,0,0,0,124.56,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.14,241.62a6.26,6.26,0,0,0,1.13.27l3.11.62c2.63.51,6.26,1.27,10.23,2.23s7.54,1.95,10.11,2.69l3,.88a5.59,5.59,0,0,0,1.14.28,5.48,5.48,0,0,0-1.08-.44c-.71-.26-1.74-.61-3-1-2.55-.82-6.11-1.86-10.1-2.82s-7.62-1.68-10.27-2.12c-1.32-.22-2.4-.38-3.14-.47A5.3,5.3,0,0,0,83.14,241.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.22,209.44a5.53,5.53,0,0,0-.7,1c-.43.68-1,1.7-1.67,3a58,58,0,0,0-6.21,21.59c-.12,1.44-.17,2.6-.17,3.41a7.33,7.33,0,0,0,0,1.26,6.5,6.5,0,0,0,.13-1.25c0-.8.16-2,.31-3.39a65.61,65.61,0,0,1,6.18-21.48c.62-1.3,1.16-2.34,1.54-3A6.5,6.5,0,0,0,113.22,209.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.57,189.86a5.37,5.37,0,0,0,.9.64L71,192.14c2.12,1.41,5,3.43,8,5.87s5.59,4.83,7.4,6.61l2.13,2.12a5.17,5.17,0,0,0,.82.76,5.22,5.22,0,0,0-.69-.87c-.46-.55-1.15-1.31-2-2.23a80,80,0,0,0-7.34-6.74,80.89,80.89,0,0,0-8.12-5.78c-1.08-.68-2-1.2-2.6-1.53A5.49,5.49,0,0,0,67.57,189.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.55,158.78s-.13.08-.33.25l-.86.77c-.75.68-1.81,1.69-3.1,2.95-2.57,2.53-6,6.14-9.59,10.33s-6.59,8.16-8.67,11.11c-1,1.47-1.87,2.67-2.42,3.52l-.63,1a1.29,1.29,0,0,0-.19.35s.11-.09.27-.3l.69-.93,2.53-3.44c2.15-2.89,5.2-6.82,8.76-11s7-7.82,9.48-10.4l3-3,.8-.83A1.47,1.47,0,0,0,110.55,158.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.14,137.49a8,8,0,0,0,.84,1.06l2.39,2.82c2,2.39,4.69,5.76,7.46,9.62s5.08,7.51,6.7,10.18c.77,1.28,1.4,2.35,1.89,3.17a8.78,8.78,0,0,0,.73,1.14,8.2,8.2,0,0,0-.57-1.23c-.4-.78-1-1.89-1.78-3.24-1.55-2.72-3.83-6.39-6.61-10.28s-5.51-7.22-7.58-9.57c-1-1.17-1.89-2.1-2.5-2.73A6.62,6.62,0,0,0,63.14,137.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.73,105.18a7.79,7.79,0,0,0-.62,1.25c-.37.81-.89,2-1.52,3.47-1.25,2.95-2.9,7-4.59,11.63s-3.12,8.78-4.09,11.83c-.48,1.52-.86,2.76-1.11,3.62a7.79,7.79,0,0,0-.34,1.35A8,8,0,0,0,87,137c.32-.92.74-2.12,1.24-3.57,1.05-3,2.51-7.19,4.21-11.77S95.71,113,96.89,110c.56-1.43,1-2.62,1.38-3.53A8.46,8.46,0,0,0,98.73,105.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.74,168.77s-10.25,42-56.13,32.37C410.61,201.14,423.91,158.62,466.74,168.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.57,232.35s-21.06,31.41-55.86,9.69C388.71,242,412.44,211.12,444.57,232.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,280.26S380.28,306.4,350.85,274C350.85,274,384.18,249.14,411,280.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.25,179.47s34.08,16.38,17.54,53.91C394.37,232,363.15,213.58,379.25,179.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.85,224.72s17,22.95-8.33,42.67C361.94,264.93,347.1,243,371.85,224.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.69,120.46s3.91,34-32.85,39.48C417.84,159.94,416.05,124.68,450.69,120.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,86s29.73,12.42,16.82,47.26C414.79,133.29,385,118.42,398,86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,135.75s39.36,4.49,35.9,47.33C415.93,183.08,375.73,175.88,380,135.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,285.28l.5-.14,1.47-.4c1.3-.34,3.22-.79,5.64-1.58a109.21,109.21,0,0,0,19.81-8.34A120.79,120.79,0,0,0,377.12,256a135.41,135.41,0,0,0,12.68-13.93l2.95-4,1.5-2c.48-.69.92-1.4,1.38-2.11.93-1.41,1.85-2.84,2.79-4.27l2.56-4.49c.43-.75.86-1.5,1.28-2.25l1.14-2.31c.76-1.54,1.53-3,2.25-4.58l2-4.63c.32-.77.66-1.52,1-2.29s.56-1.55.83-2.32l1.64-4.57c.46-1.54.91-3.07,1.35-4.58.23-.75.45-1.5.67-2.25s.37-1.5.55-2.25q.54-2.25,1.05-4.44A132.93,132.93,0,0,0,417.59,157a136.27,136.27,0,0,0-2.4-21.39c-.53-2.48-1-4.4-1.29-5.71-.15-.64-.26-1.14-.34-1.49s-.09-.51-.09-.51l.14.5.37,1.48c.32,1.3.82,3.22,1.39,5.7A133.45,133.45,0,0,1,417.9,157a131.32,131.32,0,0,1-2.84,31.82l-1,4.45c-.18.75-.33,1.52-.55,2.26s-.44,1.51-.67,2.26q-.66,2.28-1.35,4.59c-.54,1.52-1.08,3-1.64,4.59-.27.78-.55,1.55-.83,2.33s-.64,1.53-1,2.3l-2,4.65c-.73,1.53-1.5,3-2.26,4.59l-1.14,2.32-1.29,2.26-2.57,4.5-2.8,4.29c-.46.71-.91,1.43-1.39,2.11l-1.5,2-3,4a133,133,0,0,1-12.75,14,119.49,119.49,0,0,1-25.81,18.81,105.76,105.76,0,0,1-19.91,8.22c-2.43.77-4.37,1.2-5.67,1.51l-1.48.35A5.14,5.14,0,0,1,324,285.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.17,243.23a3.9,3.9,0,0,1,0,1c-.05.61-.14,1.5-.27,2.6-.27,2.19-.72,5.21-1.37,8.52s-1.36,6.28-1.94,8.41c-.29,1.07-.54,1.92-.73,2.51a4.07,4.07,0,0,1-.33.91,3.81,3.81,0,0,1,.17-.95c.16-.7.35-1.55.58-2.55.5-2.14,1.17-5.12,1.81-8.42s1.15-6.3,1.49-8.48c.17-1,.31-1.87.42-2.57A3.91,3.91,0,0,1,368.17,243.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.55,277.31a3.87,3.87,0,0,1-1-.09l-2.61-.38c-2.21-.33-5.25-.76-8.63-1.16s-6.44-.68-8.66-.87l-2.62-.23a3.64,3.64,0,0,1-1-.14,4.24,4.24,0,0,1,1,0c.62,0,1.52,0,2.64.09,2.22.11,5.3.34,8.68.74s6.43.88,8.63,1.29c1.09.2,2,.38,2.59.52A4.36,4.36,0,0,1,376.55,277.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,235.65a5.93,5.93,0,0,1-1.14.28l-3.11.61c-2.63.52-6.25,1.28-10.23,2.24s-7.54,1.95-10.11,2.69l-3.05.88a5.9,5.9,0,0,1-1.14.27,8.24,8.24,0,0,1,1.09-.44c.7-.26,1.73-.6,3-1,2.55-.82,6.12-1.86,10.1-2.83s7.62-1.67,10.27-2.11c1.32-.22,2.4-.38,3.14-.48A6.29,6.29,0,0,1,418,235.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.88,203.47a6.47,6.47,0,0,1,.7,1.05c.44.68,1,1.7,1.68,3a58.23,58.23,0,0,1,6.2,21.59c.12,1.44.18,2.61.17,3.42a6.07,6.07,0,0,1,0,1.25,7.45,7.45,0,0,1-.13-1.24c0-.81-.15-2-.31-3.4A65.8,65.8,0,0,0,390,207.64c-.62-1.29-1.15-2.33-1.54-3A7.09,7.09,0,0,1,387.88,203.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.54,183.89a5,5,0,0,1-.91.64l-2.52,1.65c-2.12,1.4-5,3.42-8,5.86s-5.59,4.83-7.4,6.61l-2.13,2.13a5.66,5.66,0,0,1-.81.75,4.75,4.75,0,0,1,.68-.87c.46-.54,1.15-1.31,2-2.23a81.5,81.5,0,0,1,7.34-6.74,79.78,79.78,0,0,1,8.11-5.78c1.08-.67,2-1.19,2.6-1.53A5.85,5.85,0,0,1,433.54,183.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.56,152.82a1.28,1.28,0,0,1,.32.25l.87.77c.75.68,1.8,1.68,3.09,2.95,2.57,2.52,6,6.13,9.59,10.32s6.59,8.17,8.68,11.11c1,1.47,1.86,2.68,2.41,3.52l.63,1a1.41,1.41,0,0,1,.19.36,1.79,1.79,0,0,1-.27-.31l-.69-.93-2.53-3.43c-2.15-2.89-5.2-6.82-8.76-11s-7-7.81-9.48-10.39l-3-3-.81-.84A1.41,1.41,0,0,1,390.56,152.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,131.52a7.24,7.24,0,0,1-.84,1.06l-2.39,2.82c-2,2.4-4.69,5.76-7.46,9.63s-5.08,7.51-6.69,10.17l-1.9,3.17a10.76,10.76,0,0,1-.73,1.15,7.34,7.34,0,0,1,.58-1.23c.39-.78,1-1.89,1.77-3.25,1.55-2.71,3.83-6.39,6.61-10.27s5.51-7.23,7.58-9.57c1-1.17,1.89-2.11,2.5-2.73A9.14,9.14,0,0,1,438,131.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.37,99.22a7.33,7.33,0,0,1,.62,1.24c.38.82.9,2,1.52,3.48,1.25,2.94,2.9,7,4.59,11.63s3.12,8.77,4.09,11.82c.49,1.53.86,2.76,1.11,3.63a8.11,8.11,0,0,1,.34,1.34,7.6,7.6,0,0,1-.5-1.29l-1.25-3.58c-1.05-3-2.51-7.19-4.21-11.77s-3.29-8.69-4.46-11.66l-1.39-3.53A10.76,10.76,0,0,1,402.37,99.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.81,347.2s5.18,20.69,0,29.08c-.21.35-.44.7-.68,1a27,27,0,0,1-31.08,10.07l-58.27-20,4.45-15.64,37.41,4.62,39.92-10.87Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.83,315.25s18.66,54.37,17.73,67.41-37,81.36-37,81.36l-15.8-7.26s6.06-19.17,10.1-35.94c2-8.47,2.84-18.76,4.4-22.92C261,385.47,266.54,379,266.54,379l-25.43-52.27Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.7,279s-5.51,15.16-1.7,29.48,39.67,73,39.67,73l41.5-24s-1.6-52.3-16.06-81.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.23,363.7s.1.15.24.46.34.77.55,1.38a23.77,23.77,0,0,1,1.19,5.34A32.77,32.77,0,0,1,296,379c-.23,1.52-.5,3.09-.91,4.71s-.95,3.26-1.54,4.91c-2.37,6.64-4.91,12.47-6.76,16.69-.93,2.11-1.7,3.8-2.25,5-.26.53-.47,1-.64,1.33a2.22,2.22,0,0,1-.26.45,2,2,0,0,1,.16-.49l.55-1.37,2.1-5c1.76-4.26,4.25-10.11,6.61-16.72.58-1.65,1.11-3.28,1.53-4.86s.7-3.16.94-4.66a33.89,33.89,0,0,0,.33-8,25.69,25.69,0,0,0-1-5.32C294.46,364.37,294.18,363.72,294.23,363.7Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.32,413.68a8.12,8.12,0,0,1,.09-1.4c.08-.91.24-2.21.46-3.81a64.43,64.43,0,0,1,2.85-12.35,56.81,56.81,0,0,1,5.71-11.32c.87-1.36,1.6-2.46,2.12-3.2a7.35,7.35,0,0,1,.85-1.12,7.73,7.73,0,0,1-.68,1.23c-.52.86-1.18,2-2,3.28a64,64,0,0,0-5.53,11.3,74.53,74.53,0,0,0-3,12.23c-.26,1.52-.47,2.79-.63,3.78A6.4,6.4,0,0,1,253.32,413.68Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,352.32a2,2,0,0,1-.19-.48l-.45-1.39c-.39-1.29-.93-3-1.58-5.13-1.33-4.34-3.22-10.31-5.46-16.85s-4.41-12.42-6-16.67l-1.9-5c-.2-.55-.36-1-.5-1.37a1.75,1.75,0,0,1-.14-.49,1.67,1.67,0,0,1,.24.45l.59,1.34c.51,1.16,1.21,2.86,2.05,5,1.69,4.21,3.91,10.08,6.16,16.63s4.08,12.55,5.33,16.91c.62,2.18,1.11,4,1.42,5.19.14.56.26,1,.35,1.41A1.61,1.61,0,0,1,294,352.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.58,311.75c-.06.07-1.3-.95-3.51-2.28a37.53,37.53,0,0,0-4-2.08,40.49,40.49,0,0,0-5.21-1.84,38.3,38.3,0,0,0-5.44-1,35.42,35.42,0,0,0-4.51-.21c-2.58.05-4.16.31-4.18.21a4.75,4.75,0,0,1,1.1-.25,23.71,23.71,0,0,1,3.07-.33,31.44,31.44,0,0,1,4.57.1,35,35,0,0,1,5.52,1,36.9,36.9,0,0,1,5.28,1.9,32.31,32.31,0,0,1,4,2.21,23.41,23.41,0,0,1,2.49,1.82A4.6,4.6,0,0,1,269.58,311.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.85,253c.3-6.86,8.4-15.48,6.31-34.94-2.2-20.41-5.3-38.4-5.3-38.4l-15.39,3.75-2.64-3.75-25.41,6-4,3.77-17.63,7.21a8.39,8.39,0,0,0-4.61,4.67L203.9,232.54l-26.69-17.95L167.1,228.3s33.6,30.83,42.38,29.94c7.87-.8,14.46-12.74,17.73-19.89l5.06,21.09s-8,14.1-9.61,38l52.78,2a10.52,10.52,0,0,0,8.56-3.86l10-12.21S284.55,259.82,284.85,253Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.67,183.43l6.81-3.12L312.23,157l9.62-40.66,17,7.11s-1.63,30.55-3.76,41S290,209,290,209Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,189.66a31.94,31.94,0,0,1,.49,3.47c.29,2.29.66,5.19,1.06,8.39s.74,6.26.92,8.41c.1,1.08.16,2,.19,2.56a3.2,3.2,0,0,1,0,.95,27.26,27.26,0,0,1-.53-3.47c-.29-2.29-.66-5.18-1.07-8.38s-.74-6.26-.91-8.42c-.09-1.08-.14-1.95-.16-2.56A3,3,0,0,1,288,189.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,244.27a4.18,4.18,0,0,1-.5-.51l-1.35-1.54c-1.2-1.39-2.88-3.33-4.92-5.71l-16.08-19L238.05,207l-.11-.13.09-.14L240,203.3l.24.33c-1.16.24-2.25.3-3.25.51l-.29.07,0-.3c.54-4.24,1-7.75,1.3-10.26q.24-1.77.39-2.82a5.21,5.21,0,0,1,.18-1,6.23,6.23,0,0,1-.06,1c-.07.71-.16,1.65-.28,2.84-.27,2.51-.65,6-1.11,10.28l-.26-.22c1-.24,2.15-.31,3.25-.55l.49-.11-.24.44c-.61,1.1-1.25,2.25-1.92,3.44l0-.27c2.71,3.22,5.72,6.77,8.87,10.5l16,19.08,4.79,5.82,1.28,1.6A3.24,3.24,0,0,1,269.74,244.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,241.38a2.73,2.73,0,0,1,.06-.66l.27-1.89c.25-1.64.65-4,1.17-6.93s1.13-6.39,1.7-10.26A97,97,0,0,0,278,209a69.56,69.56,0,0,0-1-13.67l.18.18-3.49-.83-.53-.13.47-.28,2.55-1.5-.06.29c-1.11-1.58-1.93-3.09-2.7-4.41s-1.4-2.44-1.94-3.4-1-1.65-1.27-2.14a5.22,5.22,0,0,1-.45-.75.84.84,0,0,1,.16.17,6.22,6.22,0,0,1,.39.52c.33.46.79,1.17,1.36,2.08l2,3.36c.79,1.29,1.65,2.8,2.75,4.33l.13.18-.19.12-2.53,1.53-.06-.4,3.49.8.15,0,0,.15A68.12,68.12,0,0,1,278.54,209a92.39,92.39,0,0,1-1.18,12.72c-.59,3.88-1.26,7.35-1.81,10.26s-1,5.2-1.33,6.89c-.15.77-.27,1.39-.37,1.87A3.29,3.29,0,0,1,273.69,241.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,252.14a3,3,0,0,1-.78.5c-.52.29-1.28.68-2.23,1.14a77.17,77.17,0,0,1-15.54,5.49c-1,.24-1.86.42-2.44.52a2.9,2.9,0,0,1-.92.1,30.31,30.31,0,0,1,3.27-1c2-.57,4.81-1.41,7.83-2.48s5.72-2.17,7.65-3A27.16,27.16,0,0,1,277,252.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.85,260.32a14.3,14.3,0,0,1-2.48.07c-1.53,0-3.64,0-6,.12s-4.43.27-5.95.4A12.56,12.56,0,0,1,261,261a11.61,11.61,0,0,1,2.44-.5c1.52-.22,3.64-.45,6-.55s4.47-.06,6,0A10.34,10.34,0,0,1,277.85,260.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,252.35a29.87,29.87,0,0,1-.4-5.48,29.21,29.21,0,0,1,.12-5.49,28.85,28.85,0,0,1,.4,5.48A28.23,28.23,0,0,1,274,252.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.19,259.83a8.45,8.45,0,0,1-.69-2.83,8.21,8.21,0,0,1-.18-2.92,16.55,16.55,0,0,1,.87,5.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.44,298.85a8,8,0,0,1-.16-1.49c-.07-1-.17-2.36-.33-4.07-.29-3.44-.81-8.18-1.58-13.38S275.69,270,275,266.66c-.35-1.69-.67-3.05-.88-4a7.08,7.08,0,0,1-.28-1.48,9.38,9.38,0,0,1,.48,1.43c.27.92.64,2.27,1,3.95.82,3.36,1.78,8.05,2.56,13.26s1.24,10,1.44,13.43c.11,1.73.15,3.12.16,4.09A7.6,7.6,0,0,1,279.44,298.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.74,204.07l1.18.49-1.3,3s20,24.46,25.47,29.19c6.6,5.74,6.79,6.48,6.79,6.48l-30.65-36.41,1.93-3.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.11,261.1l29.44-9.18a4.76,4.76,0,0,1-1.69,4.66,12,12,0,0,1-4.7,2.21c-7.09,2-15.64,3.24-22.94,2.31"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M211.17,239a14.09,14.09,0,0,0-8.12-7.08,3.74,3.74,0,0,1,1.63.32,10.68,10.68,0,0,1,5.95,5.18A3.94,3.94,0,0,1,211.17,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.64,211.67a1.7,1.7,0,0,1,.16.47c.1.38.22.83.36,1.38.3,1.29.71,3,1.21,5.11,1,4.31,2.36,10.28,3.82,16.87s2.72,12.51,3.68,16.91c.44,2.11.8,3.85,1.06,5.14.11.56.2,1,.27,1.4a2.57,2.57,0,0,1,.07.49,11,11,0,0,1-.53-1.85c-.31-1.28-.73-3-1.23-5.1-1-4.31-2.37-10.27-3.83-16.87S223.92,223,223,218.71c-.43-2.11-.79-3.85-1-5.14-.1-.56-.19-1-.26-1.41A2,2,0,0,1,221.64,211.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,227a2.2,2.2,0,0,0,.06,1.24,1.46,1.46,0,0,0,.9.85,1.24,1.24,0,0,0,1.31-.52,1.26,1.26,0,0,0,.14-1.4,1.52,1.52,0,0,0-1.07-.63,2.18,2.18,0,0,0-1.21.29s0-.16.22-.33a1.56,1.56,0,0,1,1-.32,1.79,1.79,0,0,1,1.44.73,1.8,1.8,0,0,1-2,2.64,1.76,1.76,0,0,1-1.1-1.18,1.51,1.51,0,0,1,0-1.07C171.29,227.07,171.42,227,171.44,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.09,122s.08-.15.37-.23a1.52,1.52,0,0,1,1.14.31,2.32,2.32,0,0,1,.93,1.5,1.76,1.76,0,0,1-1.21,1.8,2,2,0,0,1-2.13-.38,1.75,1.75,0,0,1-.35-1.74c.32-1,.88-1.3.91-1.26a8.23,8.23,0,0,0-.55,1.35,1.37,1.37,0,0,0,.33,1.31,1.57,1.57,0,0,0,1.61.24,1.3,1.3,0,0,0,.91-1.27,2.05,2.05,0,0,0-.68-1.26,1.38,1.38,0,0,0-.89-.39C324.24,122,324.11,122.09,324.09,122Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.89,190.64c6.56-8.37,15.42-15,26.12-16.7,5.52-.89,10.87,0,16.11,1.81,5.56,1.89,10.89,4.13,16.76,4.9,6.74.89,13.51.27,20.23-.5,1.3-.15,6.11-1.37,6.11-2.79,0-1.2-4.8-2.22-6.11-2.07-6.1.7-12.27,1.31-18.41.72-6-.58-11.45-2.95-17.08-4.87a37.89,37.89,0,0,0-17.2-2.12,40.8,40.8,0,0,0-16.4,5.84,52.55,52.55,0,0,0-13.57,12.35,2.52,2.52,0,0,0,0,3.43,2.45,2.45,0,0,0,3.44,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.91,190.71c6.56-8.37,15.42-15,26.12-16.7a33.19,33.19,0,0,1,16.12,1.81c5.56,1.88,10.89,4.13,16.75,4.9,6.74.89,13.52.27,20.23-.5,1.31-.15,6.09-1,6.09-2.41,0-1.2-4.78-2.6-6.09-2.45-6.1.7-12.27,1.31-18.41.71-6-.57-11.44-2.94-17.07-4.86a38.09,38.09,0,0,0-17.21-2.13,40.87,40.87,0,0,0-16.4,5.85,52.5,52.5,0,0,0-13.56,12.35,2.5,2.5,0,0,0,0,3.43,2.44,2.44,0,0,0,3.43,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M278,131.61c2.28-1.29,2.73-4.76,1.18-6.89a6.58,6.58,0,0,0-7.09-2.08,3.74,3.74,0,0,0-1.32-4.27,7.41,7.41,0,0,0-4.53-1.31c-2.15,0-4.61.67-5.49,2.63-.34-1.28-1.79-1.93-3.11-2a7.21,7.21,0,0,0-7.38,6.16,6.56,6.56,0,0,0-3.9-.83,3.08,3.08,0,0,0-2.67,2.64,4,4,0,0,0-3.62-1.23,4.75,4.75,0,0,0-2.69.93,2.38,2.38,0,0,0-.82,2.58,3.77,3.77,0,0,0-2,7.23,4.82,4.82,0,0,0,1.07,8.11,1.31,1.31,0,0,0-.51,2c.48.66.16.7,1,.68.16,2.8.38,4.95.54,7.75.11,1.81.07,4.18.73,5.86a8.05,8.05,0,0,0,4.77,3.95L275.51,151a8.54,8.54,0,0,0,1.74-8.95,1.13,1.13,0,0,1,.41-1.73,6.29,6.29,0,0,0,2.42-4.33A4.9,4.9,0,0,0,278,131.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,143c-.75-6.75-8.35-13.17-15-12.14L238.36,136l.25,3.64,5.52,49,23.39,13.94-1.37-24.09s8.54-1.84,9.78-13.22C276.55,159.66,275.82,150.46,275,143Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.83,152.81a1.45,1.45,0,0,1-1.32,1.52A1.38,1.38,0,0,1,268,153.1a1.44,1.44,0,0,1,1.32-1.53A1.39,1.39,0,0,1,270.83,152.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.23,147.84c-.17.2-1.31-.56-2.86-.48s-2.65.91-2.82.73.07-.43.55-.82a4,4,0,0,1,2.25-.81,3.72,3.72,0,0,1,2.29.62C273.13,147.42,273.31,147.76,273.23,147.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25,153.24a1.43,1.43,0,0,1-1.31,1.52,1.38,1.38,0,0,1-1.55-1.23A1.44,1.44,0,0,1,255.7,152,1.38,1.38,0,0,1,257.25,153.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.05,149.19c-.17.2-1.3-.56-2.85-.48s-2.65.91-2.83.72.08-.42.56-.81a3.93,3.93,0,0,1,4.53-.2C258,148.77,258.13,149.1,258.05,149.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,160.15a9.86,9.86,0,0,1,2.5-.58c.39-.06.76-.16.82-.43a2.09,2.09,0,0,0-.32-1.17l-1.32-3c-1.84-4.24-3.19-7.73-3-7.8s1.8,3.3,3.64,7.54c.44,1,.86,2,1.27,3a2.35,2.35,0,0,1,.28,1.55,1,1,0,0,1-.63.62,2.57,2.57,0,0,1-.66.12A10.81,10.81,0,0,1,264.18,160.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15,178.53a28.52,28.52,0,0,1-15.25-3.32s4.6,8.39,15.8,6.8Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.71,163.93a2.81,2.81,0,0,0-2.56-.92,2.51,2.51,0,0,0-1.71,1,1.63,1.63,0,0,0,0,1.86,1.86,1.86,0,0,0,2.06.42,5.81,5.81,0,0,0,1.93-1.28,1.75,1.75,0,0,0,.42-.48.55.55,0,0,0,0-.58",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.67,161.44c.25,0,.34,1.66,1.84,2.8s3.28.86,3.3,1.09-.38.35-1.14.41a4.18,4.18,0,0,1-2.75-.82,3.73,3.73,0,0,1-1.44-2.35C259.39,161.86,259.55,161.44,259.67,161.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,143.6c-.14.43-1.69.31-3.5.61s-3.26.88-3.52.51c-.12-.18.12-.59.69-1a6.21,6.21,0,0,1,5.35-.85C258,143.08,258.3,143.4,258.25,143.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.44,143.36c-.26.37-1.35,0-2.63.1s-2.36.35-2.63,0c-.12-.18,0-.54.49-.9a3.75,3.75,0,0,1,2.11-.68,3.67,3.67,0,0,1,2.13.61C272.38,142.83,272.55,143.18,272.44,143.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.72,130.17l-.7-.29c1.09-2.44-.75-5.57-3.35-6.18a6.21,6.21,0,0,0-6.62,3.37,5.35,5.35,0,0,0-6.17-2.47c-1.89.63-3.24,2.25-4.54,3.77-.29.34-.66.71-1.11.66a1.61,1.61,0,0,1-.82-.52,7.27,7.27,0,0,0-8.15-.75,10.9,10.9,0,0,0-5.07,6.81,7,7,0,0,0-.18,3.54,3.39,3.39,0,0,0,2.29,2.51,5.71,5.71,0,0,0,2.65,8.66,5.11,5.11,0,0,0,.49,1.09,53.18,53.18,0,0,0-.21,6.18,5.54,5.54,0,0,0,.54,2.58,2.1,2.1,0,0,0,2.21,1.1c.93-.26,2.23-.74,2.51-1.67.49-1.66-.05-3.95.08-5.68a5.08,5.08,0,0,0,2.56-8.88,5.52,5.52,0,0,0,7.63-4.69,7.59,7.59,0,0,0,6,2,4,4,0,0,0,2.73-1.29,2.12,2.12,0,0,0-.08-2.82,5.56,5.56,0,0,0,6.05-1A5.64,5.64,0,0,0,269.72,130.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.51,154.65c-.17-.07-6.71-1.78-6.29,4.85s6.95,4.86,6.95,4.67S241.51,154.65,241.51,154.65Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,161.78s-.11.09-.3.19a1.14,1.14,0,0,1-.86.07,2.9,2.9,0,0,1-1.48-2.49,3.94,3.94,0,0,1,.22-1.67,1.35,1.35,0,0,1,.81-.94.58.58,0,0,1,.7.28c.1.18.07.31.1.32s.14-.12.07-.39a.75.75,0,0,0-.29-.4.85.85,0,0,0-.64-.13,1.61,1.61,0,0,0-1.14,1.1,3.83,3.83,0,0,0-.28,1.87,3,3,0,0,0,1.85,2.77,1.27,1.27,0,0,0,1-.24C240,161.94,240,161.79,240,161.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,138.19a.85.85,0,0,0,.18,0l.53.06a8,8,0,0,0,2-.1,6,6,0,0,0,1.39-.45,4.29,4.29,0,0,0,1.39-1,4.11,4.11,0,0,0,.91-1.76,3.12,3.12,0,0,0-.28-2.18l-.18.17a7.57,7.57,0,0,0,4.65,1.17,7.22,7.22,0,0,0,2.58-.65,5.16,5.16,0,0,0,1.18-.76,2.72,2.72,0,0,0,.77-1.23,3.77,3.77,0,0,0,.05-1.67,10,10,0,0,0-.39-1.57,5.83,5.83,0,0,0-.67-1.43,1.81,1.81,0,0,0-1.31-.84l0,.27a4.45,4.45,0,0,0,2.94-.26,4.89,4.89,0,0,0,2.1-1.71A4.16,4.16,0,0,0,272,122a4.81,4.81,0,0,0-2.36-4.17,3.14,3.14,0,0,0-1-.38,10.09,10.09,0,0,1,.92.46,4.72,4.72,0,0,1,1.82,2.14,4.62,4.62,0,0,1,.38,1.95,3.85,3.85,0,0,1-.72,2.16,4.63,4.63,0,0,1-2,1.6,4.22,4.22,0,0,1-2.77.23l-.05.28a1.52,1.52,0,0,1,1.1.73,4.9,4.9,0,0,1,.62,1.35,5.59,5.59,0,0,1,.34,3.07,3,3,0,0,1-1.79,1.8,7.16,7.16,0,0,1-2.48.64,7.37,7.37,0,0,1-4.49-1.1l-.43-.28.25.45a2.82,2.82,0,0,1,.27,2,4,4,0,0,1-.83,1.68,4.13,4.13,0,0,1-1.32,1,5.61,5.61,0,0,1-1.34.46,8.43,8.43,0,0,1-2,.17A5.6,5.6,0,0,0,253.43,138.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,134.82s.13.09.39.16a3.1,3.1,0,0,0,2.76-.63,1.42,1.42,0,0,0,.48-1,1.08,1.08,0,0,0-.57-1l-.1.28.1,0a4.52,4.52,0,0,0,3.75-.81,4,4,0,0,0,.83-.85,1.16,1.16,0,0,0,.21-.38,9.3,9.3,0,0,1-1.16,1.06,4.53,4.53,0,0,1-3.56.7l-.09,0-1.39-.31,1.29.58a.81.81,0,0,1,.41.76,1.21,1.21,0,0,1-.38.79,2.87,2.87,0,0,1-1.45.7A5.22,5.22,0,0,1,271,134.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.75,117.17l.73-4.14s-2.42-9-2.17-10.3.52-7.47.52-7.47l6.22-7a2.22,2.22,0,0,1,2.1,1.29s2.84-.23,3.48,1.69a1.63,1.63,0,0,1,2.4,1.38,7.64,7.64,0,0,1,.17,1.8c.41.09,2.77.65,2.79,1.82a18.35,18.35,0,0,1-1,5.28,2,2,0,0,1-1.44,1.2h0l-.7,3.19s-.61,5.24-1.78,7.68l-.89,1.45-.27,6.53Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,93.93A12.35,12.35,0,0,0,332,89.28l-2.38,1.52a18.07,18.07,0,0,0,1,2.36,3.14,3.14,0,0,0,2,1.91c.53.13,1.21,0,1.38-.52A1.3,1.3,0,0,0,334,93.93Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63,90.8a1.64,1.64,0,0,0,.11.49,10,10,0,0,0,.51,1.26c.12.27.24.56.38.87a3.58,3.58,0,0,0,.6.91,2.91,2.91,0,0,0,1,.72,1.7,1.7,0,0,0,1.33,0,.88.88,0,0,0,.49-.51,1.39,1.39,0,0,0,0-.67,8.15,8.15,0,0,0-.28-1.18,11.26,11.26,0,0,0-.77-1.87c-.27-.52-.52-.91-.69-1.18a3,3,0,0,0-.3-.41,3.41,3.41,0,0,0,.23.45c.16.28.38.68.63,1.2a11.79,11.79,0,0,1,.73,1.87,11.5,11.5,0,0,1,.26,1.15,1.21,1.21,0,0,1,0,.57.68.68,0,0,1-.38.4,1.49,1.49,0,0,1-1.17,0,2.62,2.62,0,0,1-.93-.66,3.76,3.76,0,0,1-.6-.87c-.14-.29-.26-.59-.39-.85a12.57,12.57,0,0,1-.57-1.23A3.11,3.11,0,0,0,329.63,90.8Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.42,95s0,0,0,.14a2.73,2.73,0,0,0,0,.41,3.84,3.84,0,0,0,.39,1.44,4.63,4.63,0,0,0,1.45,1.67,1.63,1.63,0,0,0,1.3.28,1.08,1.08,0,0,0,.63-.37,1.19,1.19,0,0,0,.25-.72,6.62,6.62,0,0,0-.23-1.39c-.11-.44-.23-.86-.35-1.26l-.65-2.1c-.18-.59-.32-1.08-.4-1.41a2.56,2.56,0,0,0-.16-.53,2.54,2.54,0,0,0,.08.54c.07.35.18.84.35,1.44s.38,1.33.61,2.11c.11.4.22.82.33,1.25a6.81,6.81,0,0,1,.22,1.34.94.94,0,0,1-.2.6,1,1,0,0,1-.52.32,1.53,1.53,0,0,1-1.16-.25A4.54,4.54,0,0,1,333.92,97a3.9,3.9,0,0,1-.44-1.38C333.43,95.24,333.44,95,333.42,95Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.94,98.41s0,0-.06.16-.06.26-.1.47a5.66,5.66,0,0,0,0,1.77,4,4,0,0,0,1.17,2.34,2.13,2.13,0,0,0,1.46.6,1.11,1.11,0,0,0,.79-.35,1.49,1.49,0,0,0,.34-.82,22.64,22.64,0,0,0,0-3.22c-.08-1-.15-1.85-.21-2.6s-.08-1.34-.1-1.75a5.59,5.59,0,0,0,0-.65s0,.06,0,.17,0,.27,0,.48c0,.41,0,1,0,1.76s.11,1.63.17,2.61a23.71,23.71,0,0,1,0,3.17,1.3,1.3,0,0,1-.29.71.89.89,0,0,1-.65.3,2,2,0,0,1-1.33-.55,3.86,3.86,0,0,1-1.15-2.23A6.81,6.81,0,0,1,334.94,98.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.89,95.12l.1-.25.15.22a1.06,1.06,0,0,0,.48.38l.24.1-.21.15a1,1,0,0,0-.39.48l-.1.24-.14-.22a1.12,1.12,0,0,0-.48-.38l-.24-.1.21-.15A1.09,1.09,0,0,0,271.89,95.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.49,67.5l.17-.41.26.36a1.83,1.83,0,0,0,.82.66l.41.17-.36.26a1.77,1.77,0,0,0-.66.82l-.17.41-.26-.36a1.83,1.83,0,0,0-.82-.66l-.42-.17.37-.26A1.9,1.9,0,0,0,338.49,67.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.56,52.57l.28-.69.44.61a3.07,3.07,0,0,0,1.38,1.11l.69.28-.61.44a3.13,3.13,0,0,0-1.11,1.38l-.28.69-.43-.61a3.15,3.15,0,0,0-1.39-1.11l-.69-.28.61-.43A3.15,3.15,0,0,0,335.56,52.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.83,114.65l-.25-.71.73.18a3.23,3.23,0,0,0,1.77-.08l.71-.25-.17.73a3.05,3.05,0,0,0,.08,1.77l.24.71-.73-.18a3.23,3.23,0,0,0-1.77.08l-.71.25.18-.73A3.23,3.23,0,0,0,301.83,114.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.69,89c-1.27,1.53-2.58,3-3.81,4.58a5.88,5.88,0,0,0-1.26,4.79,6.41,6.41,0,0,0,3,4.12c4.67,3.2,10.39,5.9,16.19,5.19a15.57,15.57,0,0,0,10-5.72,1.25,1.25,0,0,0-1.92-1.6,13.15,13.15,0,0,1-7.41,4.69,15.18,15.18,0,0,1-7.56-.61,28.66,28.66,0,0,1-6.6-3.17,8.51,8.51,0,0,1-2.82-2.25,3.32,3.32,0,0,1,.3-3.84c1.23-1.56,2.55-3,3.82-4.58a1.25,1.25,0,0,0-1.93-1.6Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.69,61.41c1.2-1.44,2.39-2.88,3.59-4.31A3.55,3.55,0,0,1,322,55.61c1.48,0,2.41,1,3.36,2,3.36,3.46,6.48,7.9,6.82,12.86A13,13,0,0,1,329,79.58a1.25,1.25,0,0,0,1.92,1.6,15.77,15.77,0,0,0,3.84-9.63,17.7,17.7,0,0,0-2.35-8.77A31.23,31.23,0,0,0,327.3,56a8.22,8.22,0,0,0-3.86-2.72,5.76,5.76,0,0,0-5.18,1.25,46,46,0,0,0-4.49,5.26,1.25,1.25,0,0,0,1.92,1.61Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.64,96.59l-2.63,2,0,0,0,.08-.07,0,0,0-1.48,3s4.61,4.41,6.57,9.2l3.9-4.67.1-.13,3.9-4.67C338.81,100.34,333.64,96.59,333.64,96.59Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.77,96l-5.72,6.86a2.09,2.09,0,0,1-2.95.27h0a2.09,2.09,0,0,1-.27-3l5.72-6.86a2.09,2.09,0,0,1,2.95-.27h0A2.09,2.09,0,0,1,334.77,96Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,54.49,297.5,70.71l-.72.86L284,86.88c.23.38,30.78,28.54,45.13,10.2l0,0C344.63,79.61,311.43,54.66,311,54.49Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,54.49a1.42,1.42,0,0,1,.32.2c.21.14.51.35.89.65.78.58,1.9,1.47,3.3,2.68a78.15,78.15,0,0,1,10.77,11.29,41.58,41.58,0,0,1,5.49,9.3,18.75,18.75,0,0,1,1.14,12.23,15.57,15.57,0,0,1-3.2,5.92,18,18,0,0,1-5.2,4.71,15.78,15.78,0,0,1-7,2,24.53,24.53,0,0,1-7.45-.81A52.53,52.53,0,0,1,295.53,96c-2.17-1.38-4.23-2.83-6.19-4.32-1-.75-1.92-1.51-2.83-2.27l-1.36-1.16c-.45-.41-.85-.73-1.33-1.23l-.11-.12.13-.16c8-9.55,14.79-17.63,19.58-23.35L309,56.79l1.48-1.73.39-.43a1,1,0,0,1,.13-.14.88.88,0,0,1-.12.17l-.38.47-1.45,1.8-5.48,6.69L284.21,87l-.16-.16.18-.11h0l0,0,.06.06.16.14.32.3.65.57L286.81,89c.92.76,1.86,1.5,2.83,2.24,1.95,1.48,4,2.92,6.16,4.29a52.29,52.29,0,0,0,14.4,6.61,24.19,24.19,0,0,0,7.29.8,15.4,15.4,0,0,0,6.77-1.94,17.84,17.84,0,0,0,5.08-4.58,15.17,15.17,0,0,0,3.12-5.74,18.39,18.39,0,0,0-1.08-11.94A41.51,41.51,0,0,0,326,69.54a81.77,81.77,0,0,0-10.62-11.37C314,57,312.91,56,312.16,55.42l-.86-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M311,54.49c2,1.64,3.89,3.11,5.66,4.72C328.61,70.06,336.31,82.34,332,92.76l-3.3,5s3.48-12.78-3-22-15.4-19.71-15.4-19.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M352.14,98.82,335.29,119h0a6.5,6.5,0,0,1-.83-9.16L343,99.65a6.5,6.5,0,0,1,9.16-.83Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.19,
    y: 105.78,
    width: 35.33,
    height: 17,
    transform: "translate(38.13 309.94) rotate(-50.2)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.36,
    y: 110.23,
    width: 24.99,
    height: 8.33,
    transform: "translate(38.03 309.98) rotate(-50.2)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.81 77.16 312.11 78.68 316.94 74.35 317.44 80.81 323.06 84.06 317.06 86.54 315.71 92.89 311.5 87.95 305.05 88.62 308.44 83.09 305.81 77.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.26,100.12l-.08.07-.23.18a6.37,6.37,0,0,1-1,.58,7.25,7.25,0,0,1-1.69.56,10.43,10.43,0,0,1-2.34.21,16.38,16.38,0,0,1-2.84-.29l-1.57-.3c-.53-.12-1.07-.27-1.63-.4a42.79,42.79,0,0,1-7-2.62,62.33,62.33,0,0,1-6.57-3.61c-2-1.22-3.68-2.4-5.11-3.39s-2.57-1.84-3.35-2.42L288,88l-.24-.17-.07-.07.08.06L288,88l.91.65c.8.57,1.95,1.39,3.38,2.38s3.15,2.16,5.11,3.37A63.35,63.35,0,0,0,303.93,98a43.36,43.36,0,0,0,7,2.61c.56.14,1.1.29,1.63.41l1.56.31a17.42,17.42,0,0,0,2.83.29,10.36,10.36,0,0,0,2.33-.19,7.38,7.38,0,0,0,1.68-.54,6.49,6.49,0,0,0,1-.56l.24-.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.42,100.83a1.66,1.66,0,0,0-.11.44,1.25,1.25,0,0,0,.41,1,2.66,2.66,0,0,0,.95.52c.26.09.43.14.43.15a1.41,1.41,0,0,1-.46-.08,2.43,2.43,0,0,1-1-.51,1.33,1.33,0,0,1-.41-1,.9.9,0,0,1,.11-.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.45,109.78s-.07.09-.19.26a6,6,0,0,0-.49.73,6.55,6.55,0,0,0-.87,2.75,6.79,6.79,0,0,0,.41,2.86,7.24,7.24,0,0,0,.37.8,1.56,1.56,0,0,1,.14.29l-.05-.06-.13-.21a7,7,0,0,1-.4-.79,6.43,6.43,0,0,1-.45-2.89,6.36,6.36,0,0,1,1.43-3.51l.17-.18S335.45,109.77,335.45,109.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,102.87a12,12,0,0,0,2.7-4,4.13,4.13,0,0,0-.89-4.45l-7,8,7.84,10.23C334.86,108.75,333,104.12,329.94,102.87Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,111s0-.06,0-.18.08-.29.11-.53a6.39,6.39,0,0,0,0-2.05,7.34,7.34,0,0,0-1.15-2.91,7,7,0,0,0-3-2.55l0,.15a22.77,22.77,0,0,0,1.62-1.94,7.45,7.45,0,0,0,1.22-2.42,4.89,4.89,0,0,0,0-2.31,3.51,3.51,0,0,0-1.09-1.88l-.07-.06-.06.07-5,5.8-1.43,1.68-.38.46c-.09.11-.13.16-.12.17l.14-.15.4-.43,1.48-1.66,5.05-5.74h-.13a3.35,3.35,0,0,1,1,1.78,4.61,4.61,0,0,1-.06,2.21,7.17,7.17,0,0,1-1.18,2.36,24,24,0,0,1-1.59,1.93l-.09.09.12,0a6.92,6.92,0,0,1,3,2.47,7.49,7.49,0,0,1,1.17,2.84,6.82,6.82,0,0,1,.07,2C334.08,110.75,334,111,334,111Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.37,110.43c2.85-3.75,6.36-7.65,9.21-11.41",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.58,99a38.44,38.44,0,0,1-4.41,5.87c-1.23,1.47-2.35,2.79-3.34,4a9.26,9.26,0,0,1-1.46,1.58,38.49,38.49,0,0,1,4.4-5.87l3.35-4A10.37,10.37,0,0,1,343.58,99Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.57,371.53l-1.25-.31s-13.83,19.17-17.93,18.4l10.7-42.23,13.9,4.14C216.49,357.07,214.5,363.56,215.57,371.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.42,354.66a1.78,1.78,0,0,0-1.67-1.69,1.72,1.72,0,0,0-1.69,1.64,1.87,1.87,0,0,0,1.77,1.78,1.78,1.78,0,0,0,1.57-1.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.09,347.39l3.34,1L199,388.49s-1.3,1.67-2.57,1.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.16,371.34c-.2-.06,0-1.12-.44-2.3s-1.14-1.94-1-2.11,1.25.44,1.71,1.88S214.34,371.43,214.16,371.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.21,375.3c-.21,0-.34-1-1-1.9s-1.57-1.36-1.51-1.56,1.26,0,2.1,1.12S211.41,375.35,211.21,375.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.27,376.47c0-.19,1.11-.22,2.1.6s1.2,1.89,1,1.93-.65-.7-1.48-1.36S205.24,376.68,205.27,376.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.34,461.86l-.48,1.11s15.49,15.66,14.15,19.31L235.85,466l5.94-12.14A23.23,23.23,0,0,0,259.34,461.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.82,459.41a1.65,1.65,0,0,0-1.81,1.27,1.6,1.6,0,0,0,1.24,1.81,1.76,1.76,0,0,0,1.91-1.36,1.65,1.65,0,0,0-1.5-1.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.85,466l1.43-2.92,35.09,16.72s1.34,1.44.64,2.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,463.13c-.09.18-1-.13-2.18.06s-2,.74-2.1.6.6-1.08,2-1.29S259.06,463,259,463.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.13,466.46c0,.19-.95.15-1.91.65s-1.48,1.23-1.66,1.14.16-1.16,1.35-1.75S262.21,466.28,262.13,466.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.3,472.09c-.18,0,0-1,.86-1.84s1.93-.81,1.94-.62-.75.48-1.48,1.14S262.49,472.16,262.3,472.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,164.38a1.52,1.52,0,0,0-1.62-1.24l-.1,0a1.45,1.45,0,1,0,1.72,1.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.41 185.67 251.21 209.97 272.32 244.27 272.95 207.88 266.88 179.76 266.39 179.76 262.03 198.35 256.24 191.35 243.07 182.18 242.41 185.67",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.25,195.39a10.24,10.24,0,0,1-1.34-1.63c-.4-.51-.88-1.12-1.44-1.78a10.53,10.53,0,0,0-2-1.92l.39-.17a8.41,8.41,0,0,1-.31,1c-.86,2.15-1.85,3.95-2.49,5.3s-.95,2.2-1,2.19a6.19,6.19,0,0,1,.69-2.34c.55-1.39,1.5-3.24,2.33-5.33a7.19,7.19,0,0,0,.29-.9l.09-.36.3.2a9.74,9.74,0,0,1,2.09,2.06c.55.69,1,1.34,1.37,1.88A7.94,7.94,0,0,1,270.25,195.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.32,244.27a9.76,9.76,0,0,1-.39-1.73c-.24-1.2-.56-2.8-.94-4.73-.81-4-2-9.49-3.35-15.56s-2.59-11.48-3.5-15.54c-.43-1.92-.78-3.51-1-4.71a10.72,10.72,0,0,1-.32-1.75,12.12,12.12,0,0,1,.51,1.7c.3,1.1.71,2.7,1.21,4.68,1,4,2.29,9.43,3.64,15.5s2.49,11.6,3.21,15.61c.35,2,.63,3.64.78,4.77A13.88,13.88,0,0,1,272.32,244.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.22,177.81c-5.85,4.27-18.64,5.05-24.05,4.7C236.88,182,229,179,222,177.12c-7.29-1.91-14-1.79-21.27-.75s-15.94,6-20.22,11.88l3,3.21s10-8.31,19.12-9.53c8.74-1.15,14.14.71,24.4,3.42,11.68,3.09,25.8,2.41,30.25,1.21a47.81,47.81,0,0,0,12.16-5.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.51,191.46a4.35,4.35,0,0,1,.87.61c.53.41,1.29,1,2.23,1.79,1.87,1.53,4.43,3.68,7.23,6.07l.15.13-.42.14c.48-2.23.94-4.32,1.34-6.15l.08-.37.28.23c1.6,1.3,2.92,2.39,3.84,3.16a10,10,0,0,1,1.39,1.28,10.05,10.05,0,0,1-1.56-1.07c-1-.71-2.33-1.75-3.95-3l.36-.13-1.27,6.17-.09.43-.34-.29-.15-.13c-2.8-2.39-5.32-4.58-7.13-6.18-.91-.8-1.63-1.46-2.13-1.92A4.13,4.13,0,0,1,244.51,191.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.74,215.43c.06-.39-2-8.26-2-8.26l-10-4.57,1.76,9.12a46.69,46.69,0,0,0,3.58,3.2C166.25,214.86,172.74,215.43,172.74,215.43Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.77,198.66a13.34,13.34,0,1,1-14.42-12.16A13.34,13.34,0,0,1,187.77,198.66Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.77,198.66a13.34,13.34,0,1,1-14.42-12.16A13.34,13.34,0,0,1,187.77,198.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M187.77,196.93a13.34,13.34,0,1,1-14.42-12.16A13.34,13.34,0,0,1,187.77,196.93Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.16,199.41a10.29,10.29,0,0,1,9.38-11.12l.43,0a10.28,10.28,0,1,0-.06,20.53A10.28,10.28,0,0,1,165.16,199.41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "180.04 189.88 182.23 187.21 183.9 188.63 181.55 191.07 180.04 189.88",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.72,197.66a21.37,21.37,0,0,0-.62-2.44,10.37,10.37,0,0,0-4.21-5.21,10.1,10.1,0,0,0-9.62-.59,9.64,9.64,0,0,0-2.41,1.58,9.38,9.38,0,0,0-1.93,2.31,10,10,0,0,0,1,11.81,9.61,9.61,0,0,0,2.29,1.95,9.39,9.39,0,0,0,2.65,1.15,10.17,10.17,0,0,0,12.65-8.05,19.8,19.8,0,0,0,.2-2.51,8,8,0,0,1,0,2.55,10.4,10.4,0,0,1-13,8.47,10.48,10.48,0,0,1-5.19-3.22A10.47,10.47,0,0,1,165.49,193a10.11,10.11,0,0,1,2-2.41,9.85,9.85,0,0,1,2.54-1.64,10.52,10.52,0,0,1,5.46-.9,10.38,10.38,0,0,1,8.76,7.06A7.73,7.73,0,0,1,184.72,197.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.58,186.78c0,.09-.74.29-1.76,1a15.38,15.38,0,0,0-3.35,3.48,11.58,11.58,0,0,0-2,4.36c-.28,1.21-.29,2-.37,2a4.68,4.68,0,0,1,0-2.07,10.33,10.33,0,0,1,2-4.6,13,13,0,0,1,3.58-3.48A3.76,3.76,0,0,1,169.58,186.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.12,185.88c0,.14-.2.32-.54.42s-.65,0-.69-.09.21-.33.55-.42S172.09,185.74,172.12,185.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.82,206.14a8,8,0,0,1-7,.94c0-.15,1.63.1,3.56-.17S178.76,206,178.82,206.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.75,202.77c-.12-.08.1-.66.29-1.39s.27-1.35.42-1.36.3.67.08,1.49S184.87,202.85,184.75,202.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.85,194.65v9.22h-2.14v-7.51h-1.84v-1.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M173.36,214.26c-1.91-.79-8.72-1.62-8.72-1.62l.54-3.14s3.82-1.14,4.85-2.8a3.71,3.71,0,0,0,.08-3.45l-2.11.6c1.06-1.08.45-3.19.45-3.19l-2.35.5a1.83,1.83,0,0,0,.24-2.72l-1.82.59c1.1-1.2-.86-2.51-.86-2.51s-8.28,6.46-8.82,7.35.65,3.26.65,3.26a5.22,5.22,0,0,0-1.22,2.71c-.05,1.38,1.7,1.89,1.7,1.89a5.34,5.34,0,0,0,.14,2.19c.34,1.14,5.84,4.32,5.84,4.32l7.23,7.29,7.27-9.94S175.27,215.05,173.36,214.26Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,203.35a5.18,5.18,0,0,1-1.8.73,35.55,35.55,0,0,0-4.38,1.4,7.8,7.8,0,0,0-2.08,1.32c-.57.52-1,1-1.45,1.48-.82.88-1.47,1.28-1.51,1.22s.5-.53,1.24-1.46a17.26,17.26,0,0,1,1.39-1.59,7.53,7.53,0,0,1,2.19-1.45,24.26,24.26,0,0,1,4.51-1.28A11.28,11.28,0,0,1,170,203.35Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.6,213.35c0,.13-1.72-.25-4-.15l-.35,0,.1-.34c.13-.46.26-1,.36-1.48a15.06,15.06,0,0,0,.28-2.09l0-.21.22,0a7.29,7.29,0,0,0,2.3-.65c.56-.23.88-.4.91-.35s-.24.29-.77.61a6.3,6.3,0,0,1-2.43.88l.23-.23a13.39,13.39,0,0,1-.25,2.17,13,13,0,0,1-.39,1.52l-.25-.33A8.86,8.86,0,0,1,168.6,213.35Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.81,206.31A6.3,6.3,0,0,1,159,205l1.4-1.38a5.14,5.14,0,0,1,.91-.78,7.68,7.68,0,0,1,1.14-.59,26.11,26.11,0,0,1,4.21-1.24,7.4,7.4,0,0,1,1.79-.3,5.66,5.66,0,0,1-1.69.66c-1.06.34-2.56.73-4.1,1.36a7.13,7.13,0,0,0-1.07.54,5.17,5.17,0,0,0-.86.7l-1.47,1.29A6.37,6.37,0,0,1,157.81,206.31Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.43,204.19c-.05-.06.41-.53,1.19-1.24l1.38-1.22.83-.72.44-.37.23-.19a1.92,1.92,0,0,1,.29-.18,30.42,30.42,0,0,1,3.88-1.44,5.38,5.38,0,0,1,1.67-.39,6.58,6.58,0,0,1-1.54.73c-1,.41-2.36.9-3.76,1.56l-.22.13-.23.18-.44.37-.85.69-1.45,1.14A5.94,5.94,0,0,1,156.43,204.19Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.11,146.57l.37-.92.57.81a4.16,4.16,0,0,0,1.83,1.46l.92.38-.81.57a4.06,4.06,0,0,0-1.46,1.82l-.38.92-.57-.81a4.16,4.16,0,0,0-1.83-1.46l-.92-.38.82-.57A4.2,4.2,0,0,0,187.11,146.57Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.77,252.26l.37-.92.57.81a4.16,4.16,0,0,0,1.83,1.46l.92.38-.82.57a4.23,4.23,0,0,0-1.46,1.83l-.37.91-.57-.81a4.16,4.16,0,0,0-1.83-1.46l-.92-.38.82-.57A4.2,4.2,0,0,0,311.77,252.26Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.28,209.6l.37-.91.57.81a4.22,4.22,0,0,0,1.83,1.46l.92.38-.81.57a4.13,4.13,0,0,0-1.46,1.82l-.38.92-.57-.81a4.16,4.16,0,0,0-1.83-1.46L331,212l.82-.57A4.16,4.16,0,0,0,333.28,209.6Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.26,141.54l.22-.53.33.47a2.39,2.39,0,0,0,1.06.85l.53.22-.47.33a2.39,2.39,0,0,0-.85,1.06l-.22.53-.33-.47a2.39,2.39,0,0,0-1.06-.85l-.53-.22.47-.33A2.39,2.39,0,0,0,151.26,141.54Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.06,221.06l.22-.53.33.47a2.38,2.38,0,0,0,1.06.85l.54.22-.48.33a2.43,2.43,0,0,0-.84,1.06l-.22.53-.33-.47a2.51,2.51,0,0,0-1.06-.85l-.54-.21.47-.34A2.33,2.33,0,0,0,313.06,221.06Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.11,113.39,169,112l.76,1.49a7,7,0,0,0,2.7,2.85l1.44.84-1.48.76a7.08,7.08,0,0,0-2.86,2.7l-.84,1.44-.76-1.48a7,7,0,0,0-2.7-2.86l-1.44-.84,1.49-.76A6.93,6.93,0,0,0,168.11,113.39Z",
    style: {
      fill: "#AE7EDE"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultLearningImage);
export default __webpack_public_path__ + "static/media/ResultLearningImage.1a5908f50a7b6194d63be886cf2b8b60.svg";
export { ForwardRef as ReactComponent };